export default {
  // 描述文案(不具有通用性的文字)
  messages: {
    confirmDelete: 'Confirm to delete?',
    confirmSubmit: 'Confirm to perform the submission?',
    confirmAction: 'Confirm to perform {action}?',
    confirmVoidBill: 'Are you sure you want to void the selected bill?',
    confirmCancelVoidBill: 'Are you sure you want to cancel the invalidation of the selected bill?',
    noDataProcess: 'No data to process',
    mergeSubmit: 'Submitting multiple rows of objects of the current type at the same time will produce a special function of data "merging". \\n\\nAre you sure you want to perform this special function?\\n\\n (select "Cancel" if you do not understand the meaning of the so-called "merge", and check the relevant help to clarify)',
    switchEditInterfaceFirst: 'Please switch to the edit interface first',
    switchEditInterface: 'Switch to the modification interface',
    selectLessData: "Please select less than 20 rows of data to ensure the client's response speed!",
    modifySelectRow: 'modify the selected row',
    modifyResult: 'modify the result set',
    copyBill: 'copy bill',
    switchReadOnlyInterface: 'switch to read-only interface',
    selectSummaryTemplate: 'Please select the summary table template in the query column',
    notDefineSummaryTemplate: 'The current table does not define a summary table template',
    mustDataType: 'Must be date type',
    mustDigital: 'Must be digital',
    clickClearSetting: 'Click to clear the current condition settings',
    tickToConfirm: 'Please tick the first line to confirm!',
    reenterReport: 'The current operation interface is not a report interface layout, please click the report center tab to re-enter the report module and try again',
    collectionSelected: 'The collection has been selected',
    collectionExcluded: 'The collection has been excluded',
    noPermissionToAccess: 'The user does not have permission to access',
    moreFilters: 'more filters',
    addCondition: 'add condition',
    viewSelectedResults: 'view selected results', 
    pleaseEnterAgain: 'Please enter again',
    uploadWarning: 'Note: Do not place macros or icons in the uploaded file, do not change the order of the columns, and do not use formulas in the data.',
    downloadTemplateRemark: 'download template',
    fileSizeTip: 'maximum file length',
    colorSizeSave: 'color size save',
    saveAsTemplate: 'save as template',
    originalWarehouse: 'original warehouse',
    targetWarehouse: 'target warehouse',
    VIPType: 'VIP type',
    selectedData: '{total} pieces of data have been selected',
  },
  // 具有通用性的文案
  tips: {
    serverProcessing: 'server processing',
    categoryNavigation: 'category navigation',
    systemMaintenance: 'system maintenance',
    operationTimeout: 'operation timeout',
    noPermission: 'permission denied',
    abnormal: 'abnormal',
    report: 'report',
    statistics: 'statistics',
    printWithTemplate: 'print with template',
    shortMessage: 'short message',
    dialog: 'dialog',
    hasBeenSelected: 'has been selected',
    hasBeenExcluded: 'has been excluded',
    notify: 'notify',
    priority: 'priority',
    sendTime: 'send time',
    allNotifications: 'all notifications',
    cancelVoid: 'cancel void',
    more: 'more',
    copyPermission: 'copy permissions',
    notEmpty: 'can not be empty',
    hiddenColumn: 'hidden column',
    noData: 'no data',
    all: 'all',
    queryCondition: 'query condition',
    filterCondition: 'filter condition',
    filterResults: 'filter results',
    color: 'color',
    size: 'size',
    templateName: 'template name',
    sourceTable: 'source table',
    targetTable: 'target table',
    targetDescription: 'target description',
    phone: 'phone',
    sex: 'sex',
    male: 'male',
    female: 'female',
    secret: 'secret',
    region: 'region',
    yes: 'yes',
    no: 'no',
    frequency: 'frequency',
    yuan: 'Yuan',
    one: 'one',
    number: 'number',
    loading: 'loading',
    fullscreen: 'fullscreen',
    exitFullscreen: 'exit fullscreen',
    today: 'today',
    month: 'month',
    day: 'day',
    festival: 'festival',
    notFestival: 'not a festival',
    yesterday: 'yesterday',
    allow: 'allow',
    condition: 'condition',
    attachment: 'attachment',
    uploadAttachment: 'upload attachment',
    name: 'name',
    quantity: 'quantity',
    unfold: 'unfold',
    fold: 'fold',
    operation: 'operation',
    point: 'point'
  },
  feedback: {
    alert: 'alert',
    warning: 'warning',
    error: 'error',
    success: 'success',
    collectionSuccess: 'collection success',
    collectionFailed: 'collection failed',
    unfavoriteSuccessfully: 'unfavorite successfully',
    failedToUnfavorite: 'failed to unfavorite',
    selected: 'selected',
    saveSuccess: 'saved successfully'
  },
  actions: {
    globalSearch: 'global search',
    selectAll: 'select all',
    clear: 'clear',
    match: 'match',
    exclude: 'exclude',
  },
  buttons: {
    print: 'print',
    back: 'back',
    bulkSubmission: 'bulk submission',
    batchEdit: 'batch edit',
    import: 'import',
    export: 'export',
    add: 'add',
    save: 'save',
    delete: 'delete',
    deleteDetails: 'delete details',
    cancelSubmission: 'cancel submission',
    submit: 'submit',
    refresh: 'refresh',
    batchAdd: 'batch add',
    copy: 'copy',
    invalid: 'invalid',
    reset: 'reset',
    filter: 'filter',
    cancel: 'cancel',
    confirm: 'confirm',
    close: 'close',
    modify: 'modify',
    find: 'find',
    selectFile: 'select file',
    search: 'search',
    exit: 'exit',
    download: 'download'
  },
  // 表单(具有通用性的文案)
  form: {
    inputPlaceholder: 'please enter ',
    selectPlaceholder: 'please select ',
  },
  // table文件下.vue
  table: {
    index: 'index',
    summation: 'summation',
    total: 'total',
    boxNumber: 'box number',
    specification: 'specification',
    deleteBoxNumber: 'delete box number',
    boxlessScanning: 'boxless scanning',
    viewLog: 'view log',
    enterQueryContent: 'please enter the query content',
    selectDeleteDetail: 'please select the details to be deleted'
  },
  // advancedSearch.vue
  advancedSearch: {
    infoFiltering: 'information filtering',
    enterComplete: 'please enter completely',
    selectedCondition: 'selected conditions',
    advancedSearch: 'member advanced search',
    baseInfo: 'basic information',
    cardNumber: 'member card number',
    typeOrLevel: 'member type/level',
    cardDate: 'card opening date',
    availablePoints: 'available points',
    followAccount: 'whether to follow the official account',
    notFollowed: 'not followed',
    followed: 'followed',
    unfollowed: 'unfollowed',
    wxTiedToCard: 'whether the WeChat mini program is tied to the card',
    wxCardTiedCard: 'whether the WeChat membership card is tied to the card',
    taobaoCard: 'whether Taobao is tied to the card?',
    memberLabel: 'member label',
    consumptionAttr: 'consumption attributes',
    lastPurchaseDate: 'last purchase date',
    consumptionAmount: 'cumulative consumption amount',
    consumptionNumber: 'number of consumption',
    associateRate: 'associate rate',
    averageCustomerPrice: 'average customer price',
    lifeCycle: 'life cycle',
    newOldMember: 'new and old members',
    newMember: 'new member',
    oldMember: 'old member',
    activityLevel: 'activity level',
    activeMember: 'active member',
    inactiveMember: 'inactive member',
    sleepingMember: 'sleeping member',
    lostMember: 'lost member',
    templateIsRequired: 'template name cannot be empty',
    searchSuccessful: 'search successfully'
  },
  // serachComponent文件夹下所有.vue
  searchComponent: {
    matchedMatch: '{num} members matched',
    pleaseImport: 'please import',
    importSuccess: '{msg} import successfully',
    selectMore: 'please select one or more',
    selectMemberType: 'please select membership type',
    selectMemberLevel: 'please select membership level',
    moreOr: 'more or ',
    addTag: 'please add tags',
    selectTag: 'choose tags',
    fullDateFormat: 'yyyy year MM month dd day',
    startDate: 'start date',
    endDate: 'end date',
    toDate: '(include）to',
    lastWeek: 'last week',
    lastMonth: 'last month',
    lastThreeMonths: 'last three months',
    to: ' to ',
    selectCumulativeMonth: 'please select cumulative month',
    grandTotal: 'grand total',
    nearlyMonths: 'nearly {num} months',
    cardShop: 'card shop warehouse',
    selectedItems: '{num} selected'
  },
  // elememt/tableobj.vue 
  tableobj: {
    clickUpload: 'click upload'
  },
  // tablelist/fkdialog.vue 
  fkdialog: {
    searchResult: 'search result',
    multipleSelection: 'multiple selection',
    recordExists: 'The record is already in the list',
    onlySelectOne: 'Only one piece of data can be selected',
    modifyQuery: 'The number of queries has exceeded the upper limit, please modify the query conditions'
  },
  // tablelist/importDialog.vue 
  importDialog: {
    fileName: 'file name',
    exportLocation: 'export location',
    waitImport: 'The data is being imported, please wait',
    downError: 'download error message',
    dataError: 'The {num} record reported an error',
    importFile: 'Please select the file to import',
  },
  // custompage/crm/guideTagPop.vue
  guideTagPop: {
    tagClassification: 'tag classification',
    enterContent: 'please enter content',
    labelSuccess: 'labelled successfully'
  },
  // page文件夹下所有.vue 
  page: {
    packStandard: 'read in the packing standard'
  },
  // calendaar.vue
  calendar: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    sun: 'Sun',
    one: 'one',
    two: 'two',
    three: 'three',
    four: 'four',
    five: 'five',
    six: 'six',
    seven: 'seven',
    eight: 'eight',
    nine: 'nine',
    ten: 'ten'
  },
  // datepicker文件夹下.vue
  datepicker: {
    selectDate: 'please select a date',
    selectDateTime: 'please select a date time',
    selectTime: 'please select time',
    aWeekAgo: 'a week ago'
  },
  // dialog文件下screenDialog.vue 
  screenDialog: {
    setParams: 'product search page (can set parameters)'
  },
  // element文加下img.vue和img3.vue 
  img: {
    next: 'next',
    defaultPicture: 'default picture',
    pictureUploadFormat: 'Upload pictures can only be in JPG, PNG, GIF format!',
    pictureUploadSize: 'Upload image size cannot exceed 2MB!',
    deleteImg: 'This operation will permanently delete the picture, do you want to continue?',
  },
  // element/ItemCol.vue 
  itemCol: {
    closeStatus: 'closed status',
    allowExcess: 'whether to allow excess',
    closed: 'closed'
  },
  // element/upload.vue 
  upload: {
    maximumFile: 'Maximum allowable upload of files within 10MB!',
    allowType: 'The allowed file types are: xls, xlsx, xlsm, doc, docx!',
    uploadLimit: 'Only upload up to three files!'
  },
  // input文件下.vue 
  input: {
    storeCode: 'store code',
    storeName: 'store name',
    store: 'store',
    userGroup: 'user group',
    productNumber: 'product number',
    enterBarcode: 'please enter the barcode, product code',
    matrixEntry: 'matrix entry',
    selectStore: 'please select a store',
    addBarcode: 'single barcode added successfully',
    promotionCategories: 'promotion categories',
    promotionalClass: 'promotional class',
    category: 'category',
    enterProductCode: 'please enter the product code'
  },
  // report文件下.vue
  report: {
    messageNotification: 'message notification',
    waitRequest: 'Processing request, please wait'
  },
  // views/custompage文件下.vue 
  custompage: {
    matchInLib: 'match in library',
    matchAvailable: 'match available',
    shop: 'shop',
    shipInStore: 'shipped in store',
    inStore: 'in store',
    shipmentAvailable: 'shipment available',
    available: 'available',
    receiptInStore: 'receipt in store',
    receiptAvailable: 'receipt available',
    inventoryStatus: 'The colored area is the inventory of the shipping store',
    rowTotal: 'row total',
    enterDigit: 'The input value cannot be greater than {num} digits',
    barcodeNotExist: 'The rectangular box means: the barcode does not exist in the barcode file',
    hangzhouStore: 'Hangzhou Store',
    matchSuccessfully: 'match successfully'
  },
  // jordanComponents文件下.vue
  jordanComponents: {
    uploadFile: 'upload files',
    overwriteNote: 'overwrite original note',
    appendNote: 'append to original note',
    importFail: 'import failed'
  }
};
